export const ARROW_DOWN = 'ArrowDown'
export const ARROW_UP = 'ArrowUp'
export const ARROW_LEFT = 'ArrowLeft'
export const ARROW_RIGHT = 'ArrowRight'
export const DESCRIPTION_LABEL_ID = 'k5kit-teach-button-toggle-label'
